<template>
  <tr v-if="isBookable">
    <th>{{ date }}</th>
    <th
      :style="avaStyle"
      :title="avaDesc" >{{ avaLabel }}</th>
    <th>
      <span class="pointer"
        :style="'text-decoration:' + (hasDiscount ? 'line-through' : '')"
        @click="$emit('showPriceDetails', depDate)"
      >
        <small v-translate>de la</small>
        {{ fullPrice.toFixed(2) }} {{ currency }}
      </span>
    </th>
    <th class="text-danger">
      <template v-if="hasPrice && hasDiscount">
        <span @click="$emit('showPriceDetails', depDate)" class="pointer">
          <small>de la</small>
          {{ price.toFixed(2) }} {{ currency }}
        </span>
      </template>
    </th>
    <td class="text-right">
      <b-button variant="primary" size="sm" @click="$emit('selectDate', depDate)"><span v-translate>Book</span></b-button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import availability from '@/app/private/shared/availability'

export default {
  props: {
    depDate: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  computed: {
    date () {
      return moment(this.depDate.date).format('DD-MM-YYYY')
    },
    availability () {
      return availability.find(el => el.name === this.depDate.availability)
    },
    avaLabel () {
      return this.availability.shortLabel
    },
    avaDesc () {
      return this.availability.label
    },
    avaStyle () {
      return { color: this.availability.colour }
    },
    price () {
      return this.depDate.price.gross + this.depDate.price.tax
    },
    fullPrice () {
      return this.depDate.price.gross + this.depDate.price.tax + this.depDate.price.discount
    },
    hasDiscount () {
      return !!this.depDate.price.discount
    },
    hasPrice () {
      return !!this.price
    },
    isBookable () {
      return this.availability.name !== 'unavailable'
    }
  }
}
</script>
